"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rogueAnim = exports.rogueCursor = exports.getSpellData = exports.getSpellStats = void 0;
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueRunner_sidecar_1 = require("../scene/rogueRunner-sidecar");
var rogueGlyphs_sidecar_1 = require("../targeting/rogueGlyphs-sidecar");
var lineAlgo_sidecar_1 = require("../util/lineAlgo-sidecar");
var rogueAanimManager_sidecar_1 = require("./rogueAanimManager-sidecar");
var rogueSpellData_sidecar_1 = require("./rogueSpellData-sidecar");
var rogueSpellTeleport_sidecar_1 = require("./rogueSpellTeleport-sidecar");
var key = 'teleport';
var getSpellStats = function () {
    return rogueSpellData_sidecar_1.rogueSpellData.getSpellStats(key);
};
exports.getSpellStats = getSpellStats;
function getSpellData() {
    return {
        key: key,
        name: 'Teleport',
        desc: 'Quickly move within LoS',
        castType: 'target',
        targetCursor: rogueSpellTeleport_sidecar_1.rogueSpellTeleport.rogueCursor,
        targetFinder: 'teleport',
        selfCast: null,
        hotkey: 't',
        isBought: false,
        cost: 2,
        maxUses: 6,
        usesLeft: 0,
        baseDamage: 0,
        baseRange: 8,
        baseRadius: 0,
        duration: 0,
        upgrades: [
            {
                key: 'range',
                name: '',
                effectAmount: 5,
                cost: 1,
                isBought: false,
            },
            {
                key: 'max-uses',
                name: '',
                effectAmount: 3,
                cost: 2,
                isBought: false,
            },
        ],
    };
}
exports.getSpellData = getSpellData;
function rogueCursor(gridX, gridY, activate) {
    var monster = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
    if (monster) {
        var path = getPath(monster.x, monster.y, gridX, gridY);
        for (var i = 0; i < path.length; i++) {
            var pathPart = path[i];
            rogueGlyphs_sidecar_1.rogueGlyphs.write(pathPart.x, pathPart.y, '*', rogueDef_sidecar_1.rogueDef.colors.lightBlue);
        }
        if (activate) {
            rogueAanimManager_sidecar_1.rogueAanimManager.addAnim(rogueAnim(monster, gridX, gridY));
        }
    }
}
exports.rogueCursor = rogueCursor;
var getPath = function (x1, y1, x2, y2) {
    var path = [];
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    var ss = (0, exports.getSpellStats)();
    lineAlgo_sidecar_1.lineAlgo.drawLineBresenham(x1, y1, x2, y2, function (x, y, count) {
        var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, x, y);
        if (!t) {
            return false;
        }
        if (!rogueMaps_sidecar_1.rogueMaps.isPassibleT(t)) {
            return false;
        }
        if (count >= ss.range) {
            return false;
        }
        path.push({ x: x, y: y });
        return true;
    });
    return path;
};
function rogueAnim(monster, x, y) {
    var tx, ty, path, delay, _loop_1, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tx = x;
                ty = y;
                path = getPath(monster.x, monster.y, tx, ty);
                delay = 0.1;
                _loop_1 = function (i) {
                    var pathPart;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                pathPart = path[i];
                                tx = pathPart.x;
                                ty = pathPart.y;
                                return [4 /*yield*/, {
                                        delay: delay,
                                        action: function () {
                                            rogueGlyphs_sidecar_1.rogueGlyphs.write(pathPart.x, pathPart.y, '*', rogueDef_sidecar_1.rogueDef.colors.lightBlue, delay);
                                        },
                                    }];
                            case 1:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < path.length)) return [3 /*break*/, 4];
                return [5 /*yield**/, _loop_1(i)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4:
                rogueMonsters_sidecar_1.rogueMonsters.setPos(monster, tx, ty);
                // yield { delay: 0.2 }
                rogueRunner_sidecar_1.rogueRunner.setPlayerUsedTurn();
                return [2 /*return*/];
        }
    });
}
exports.rogueAnim = rogueAnim;
